import React from "react"
import { useStore } from "@/store"
import { DateTime } from "luxon"
import { GetReservationsQuery } from "@/graphql/graphql"
import Reservation, { OnReservationFocusCallback } from "./reservation"

const ReservationsLayer = ({
  reservations,
  onReservationFocus,
}: {
  reservations: GetReservationsQuery["venue"]["reservations"]["nodes"]
  onReservationFocus?: OnReservationFocusCallback
}) => {
  const { calendarDimensions } = useStore()

  if (!reservations) {
    return null
  }

  const reservationsWithDimensions = reservations
    .map((reservation: GetReservationsQuery["venue"]["reservations"]["nodes"][number]) => {
      const startTime = DateTime.fromISO(reservation.startTime)
      const endTime = DateTime.fromISO(reservation.endTime)

      return {
        ...reservation,
        startTime,
        endTime,
        position: calendarDimensions.getReservationPosition({
          tableId: reservation.table.id,
          startTime,
          endTime,
        }),
      }
    })
    .filter((reservation) => !!reservation.position)

  return (
    <div
      className="flex-1 flex-row min-w-min z-20 pointer-events-none"
      style={{
        position: "absolute",
        top: 0,
        left: 0,
        width: calendarDimensions.canvas.width,
        height: calendarDimensions.canvas.height,
      }}
      data-testid="panel-reservations-calendar-reservations-layer"
    >
      {reservationsWithDimensions.map((reservation) => (
        <Reservation key={reservation.id} reservation={reservation} onReservationFocus={onReservationFocus} />
      ))}
    </div>
  )
}

export default ReservationsLayer
